import { cn } from '@/lib/utils';

/**
 * The shared look of the controls floating over the map: white so they read against
 * the tiles, and the same blue as any other pressed control once they are on. Kept in
 * one place because the timeline toggle has to match without being a popover itself.
 */
export const mapControlProps = (active: boolean) =>
  ({
    variant: active ? 'default' : 'outline',
    size: 'icon',
    className: cn('shadow-md', !active && 'bg-white')
  }) as const;
